export default "__VITE_ASSET__940939db__"